import { render, staticRenderFns } from "./DeveloperListApartmentModels.vue?vue&type=template&id=2ed5cb98&"
import script from "./DeveloperListApartmentModels.vue?vue&type=script&lang=js&"
export * from "./DeveloperListApartmentModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports